import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import {
  NavigationCommand,
  NavigationInstruction,
  RedirectToRoute,
  RoutableComponentCanActivate,
  RouteConfig,
} from "aurelia-router";
import { ApplicationState } from "../../services/application-state";
import { ProductfinderResult } from "./productfinder-result";

@autoinject
export class ProductfinderOutput implements RoutableComponentCanActivate {
  private result: ProductfinderResult;

  constructor(
    private i18n: I18N,
    private state: ApplicationState,
  ) {
    this.result = state.productfinderResult;
  }

  canActivate(
    params: any,
    routeConfig: RouteConfig,
    navigationInstruction: NavigationInstruction,
  ): boolean | NavigationCommand {
    // if someone tries to activate this component/route without having
    // a valid result then redirect to an error page
    if (!this.result) {
      return new RedirectToRoute("noresult");
    }
    return true;
  }

  get note(): string {
    let key = "productfinder.notes.output";

    let note = this.i18n.tr(key);

    if (note === key) return "";

    return note;
  }
}
